/*
 * File: ui-reference.ts
 * File Created: 2024-09-09 09:41:37
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-09 02:26:07
 * Modified By: Val Liu
 * -----
 */

import { ObjectHelper } from "../../utilities";
import { IQuickUnit, QuickHelper } from "../../utilities/quick-helper";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIRelationPair,
    EUITagRuleUnion,
} from "../core";

// @uiReference: this field is a reference to another deep field.
// ex: incomeAndExpenseSubject.propertyRentalContract.customer.name

@UITag.set()
export class uiReference extends BaseUITag {
    appliedTo: EUITagTarget[] = [
        EUITagTarget.TableHeaderCell,
        EUITagTarget.TableSearch,
        EUITagTarget.TableBodyCell,
    ];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.String];
    allowNullRule: boolean = false;

    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input) as string;
        if (rule == null) return null;
        /// property type
        const { type, name } = input.meta.attr;

        let moreTags: IUITagMoreTagsUnit[] =
            input.target === EUITagTarget.TableHeaderCell
                ? [
                      {
                          tag: "uiSort",
                          rule: false,
                      },
                  ]
                : input.target === EUITagTarget.TableBodyCell
                  ? [
                        {
                            tag: "uiConverter",
                            rule: (o) => {
                                return ObjectHelper.unwrap(rule, o.row) ?? null;
                            },
                        },
                    ]
                  : [
                        {
                            tag: "uiSearch",
                            rule: () => ({
                                /// disable the original search
                                [name]: null,
                                /// apply the new reference rule
                                [rule]: [type.name, true],
                            }),
                        },
                    ];
        return {
            specials: {
                moreTags,
            },
        };
    }
}
